import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ImageSlider",
    component: () => (__SERVER__ ? require("./image-slider-view") : import("./image-slider-view"))
});

export default definition;
